import React, { useEffect } from 'react';

import BannersAero from './BannersAero';
import IncrementCounter from './IncrementCounter';
//  import Testimonials from './Testimonials';
import Stack from './Stack';
import Automotivemobilitecards from './Automotivemobilitecards';
import AutomobilityTabs from './AutomobilityTabs';
import Automobilityverticaltabs from './Automobilityverticaltabs';
import AerospaceIntroductioncards from './AerospaceIntroductioncards';
import AerospaceanimatedCards from './AerospaceanimatedCards';
import AerospaceInsightsCards from './AerospaceInsightsCards';
import Aerospacepartnerscompany from './Aerospacepartnerscompany';
import Aerospacehovercards from './Aerospacehovercards';
import Aerospacetabsgood from './Aerospacetabsgood';
import Industrypatners from './Industrypatners';
import Aeroverticaltabs from './Aeroverticaltabs';

import JobApplypage from './JobApplypage';
import Hiringrequestform from './Hiringrequestform';
import Mechanicalhiringbanner from './Mechanicalhiringbanner';
const MechanicalHiringpage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
  // Scroll to the top of the page when the component mounts

  return (
    <div style={{ background: '#fff' }}>
      <Mechanicalhiringbanner />
  
      {/* <Hiringrequestform  /> */}
      <JobApplypage />
      <style>
        {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
      </style>
    </div>
  )
}

export default MechanicalHiringpage;